<template>
  
  <div id="chatterModal"
       class="overflow-auto">

  <loading :active.sync="loading" :is-full-page="false"></loading>
    <b-table head-variant="light"
             :fields="fields"
             id="my-table"
             :items="items"
             :per-page="tableType === 'user' ? undefined : perPage"
             :current-page="tableType === 'user' ? undefined : currentPage"
             small
             ref="selectableTable"
             class="mb-0"
             hover
             outlineless
             borderless
             @row-clicked="onRowClicked"
             align="center">
      <!-- Define a scoped slot for the 'selected' column -->
      <template v-slot:cell(selected)="data">
        <!-- selected 아이콘 추가 -->
        <span aria-hidden="true"
              v-if="data.item.selected || data.item.show"
              :class="{ 'text-danger font-weight-bold': data.item.show }">
          <svg xmlns="http://www.w3.org/2000/svg"
               width="16"
               height="16"
               viewBox="0 0 16 16"
               fill="none">
            <rect x="0.5"
                  y="0.5"
                  width="15"
                  height="15"
                  rx="3.5"
                  fill="#1755CC"/>
            <path d="M5 8L7 10L11 6"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"/>
            <rect x="0.5"
                  y="0.5"
                  width="15"
                  height="15"
                  rx="3.5"
                  stroke="#1755CC"/>
          </svg>
        </span>
        <!-- not selected 아이콘 추가 -->
        <span aria-hidden="true"
              v-else>
          <svg xmlns="http://www.w3.org/2000/svg"
               width="16"
               height="16"
               viewBox="0 0 16 16"
               fill="none">
            <g clip-path="url(#clip0_939_25212)">
              <rect x="0.5"
                    y="0.5"
                    width="15"
                    height="15"
                    rx="3.5"
                    fill="white"
                    stroke="#C4C4CD"/>
            </g>
            <defs>
              <clipPath id="clip0_939_25212">
                <rect width="16"
                      height="16"
                      rx="4"
                      fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </span>
        <span class="sr-only"
              v-if="data.item.selected || data.item.show">Selected</span>
        <span class="sr-only"
              v-else>Not selected</span>
      </template>
    </b-table>
    <!-- navigation arrows -->
    <b-icon class="h1 arrow arrow-left"
            icon="chevron-left"
            variant="secondary"
            @click="goLeft"
            v-if="currentPage > 1 && tableType !== 'user'"></b-icon>
    <b-icon class="h1 arrow arrow-right"
            icon="chevron-right"
            variant="secondary"
            @click="goRight"
            v-if="currentPage < maxPage && tableType !== 'user'"></b-icon>
    <!-- /navigation arrows -->
    <b-pagination v-if="false"
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  aria-controls="my-table"
                  align="center"></b-pagination>
  </div>
</template>
<script>

import Loading from 'vue-loading-overlay';
export default {
  components: [
    Loading,
  ],
  props: {
    tableType: String,
    selectType: String,
    selectedValues: Array,
    projectId: String,
    keyword: String,
    notForShowValues: Array,
    list: null,
  },
  watch: {
    selectedValues :{
      deep:true,
      immediate: true,
      handler() {
        this.selected = JSON.parse(JSON.stringify(this.selectedValues));
      },
    },
  },
  computed: {
    typeOptions() {
      return this.$store.getters['chatter/typeOptions']
    },
    maxPage() {
      return this.rows / this.perPage;
    },
    rows() {
      if (this.tableType == 'user') {
        return this.items.length
      } else {
        return this.total;
      }
    },
    fields() {
      let returnField = []
      switch (this.tableType) {
        case "chatter":
          returnField = [
            {
              key: "selected",
              label: "",
              thClass: ["text-center"],
              class: ["text-center", "align-middle", "columnRate3"]
            },
            {
              key: "type",
              label: "Type",
              class: ["text-center", "align-middle", "columnRate3"]
            },
            {
              key: "chatId",
              label: "Chat ID",
              class: ["text-center", "align-middle", "columnRate15"]
            },
            {
              key: "status",
              label: "Status",
              class: ["text-center", "align-middle", "columnRate15", "custom-style"],
            },
            {
              key: "formatedTitle",
              label: "Title",
              thClass: ["text-center", "columnRate65"],
              tdClass: ["text-left", "align-middle", "custom-style", "columnRate65"]

            }
          ];
          return returnField;
        case "user":
          return [
            {
              key: "selected",
              label: "",
              thClass: ["text-center"],
              class: ["text-center", "align-middle", "columnRate10"]
            },
            {
              key: "text",
              label: "User",
              class: ["text-center", "align-middle", "columnRate25"]
            },
            {
              key: "value",
              label: "User ID",
              thClass: ["text-center", "columnRate65"],
              tdClass: ["text-left", "align-middle", "custom-style", "columnRate65"]

            }
          ];

        default:
          return "c";
      }
    },
  },
  data() {
    return {
      seletedValues: [],
      perPage: 10,
      currentPage: 1,
      items: [],
      total: 0,
      selected: [],
      serial: null,
      loading: false,
    };
  },
  methods: {
    goLeft() {
      this.currentPage = this.currentPage - 1;
    },
    goRight() {
      this.currentPage = this.currentPage + 1;
    },

    onRowClicked(item) {
      if (item.show) return;
      if (this.selectType == 'single' && item.selected != true) {
        this.items.forEach(item => item.selected = false)
        this.selected = [];
      }
      item.selected = !item.selected;
      if(item.selected) {
        // 선택한 아이템 목록에 추가
        let selectTarget = item;
        if(this.tableType === 'user') {
          selectTarget = item.value;
        }
        this.selected.push(selectTarget);
      } else {
        // 선택한 아이템 목록에서 삭제
        if(this.tableType === 'user') {
        const index = this.selected.indexOf(item.value);
          if (index !== -1) {
            this.selected.splice(index, 1);
          }
        } else if(this.tableType === 'chatter') {
          this.selected = this.selected.filter(prevItem => prevItem.chatId !== item.chatId);
        }
      }
      this.returnSelectedList();
    },
    assigneeOptions() {
      let memberList = this.$store.getters['chatter/getAllProjectInfo']
        .filter(obj => obj.projectId === this.projectId)[0]
      if (memberList) {
        memberList = memberList.projectUserList.map(item => ({
          value: item.userId,
          text: item.userName
        })).slice().sort((a, b) => {
          return a.text.localeCompare(b.text);
        })
        return memberList;
      } else {
        return [];
      }
    },
    reformatState(strStatus) {
      let arrStrStatus = strStatus.split("_");
      let result = '';
      for (let i in arrStrStatus) {
        let str = arrStrStatus[i]
        result = result + " " + str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      }
      return result
    },
    // 24-02-13 yhkim@hiaas.co.kr
    // 삭제 플래그 추가
    // 모달에서 데이터 가져올 때 삭제플래그가 true 인것 제외하고 부모 컴포넌트에 넘겨줌
    returnSelectedList() {
      // this.selected = this.items.filter(item => item.selected === true && !item.deleted);
      
      // let selectedList = [];
      // if (this.tableType == 'user') {
      //   selectedList = this.selected.map(item => item.value);
      // } else {
      //   selectedList = this.selected;
      // }
      this.$emit("set-result", this.selected);
    },
    clearSelectedselectedes() {
      this.items.forEach(item => {
        item.selected = false;
      });
    },
    reformatMemoTitle(chat){
      return (chat.businessCategory != null && chat.businessCategory !='') ? '[' + chat.businessCategory + '] ' + chat.title : chat.title;
    },
    async retreiveData() {
      try {
        this.loading = true;
        switch (this.tableType) {
          case "user":
            await this.retrieveUser();
  
            // 24-02-13 yhkim@hiaas.co.kr
            // 사용자에게 보여주지 않는 값에 대한 필터 로직 추가
            this.items = this.items.filter(item => !this.notForShowValues.includes(item.value));
            //  User : String Array
            this.items = this.items.map(item => {
              if (this.selectedValues.includes(item.value)) {
                return { ...item, selected: true };
              } else {
                return { ...item, selected: false };
              }
            });
            // this.items = this.items.map(item => {
            //   if (this.notForShowValues.includes(item.value)) {
            //     return { ...item, show: true };
            //   } else {
            //     return { ...item, show: false};
  
            //   }
            // });
            break;
          case "chatter":
            await this.retreiveChatter();
  
            // 24-02-13 yhkim@hiaas.co.kr
            // 사용자에게 보여주지 않는 값에 대한 필터 로직 추가
            if (this.notForShowValues) {
              this.items = this.items.filter(item => !this.notForShowValues.includes(item.chatId));
            }
              
            //  Chatter : Object Array
            this.items = this.items.map(item => {
              if (this.selectedValues.some(selectedItem => selectedItem != null && selectedItem.chatId === item.chatId)) {
                return { ...item, selected: true};
              } else {
                return { ...item, selected: false};
              }
            });
            // this.items = this.items.map(item => {
            //   console.log()
            //   if (this.notForShowValues.includes(item.chatId)) {
            //     return { ...item, selected: true};
            //   } else {
            //     return { ...item, selected: false};
            //   }
            // });
  
            break;
          default:
            break;
        }
        
      } catch(e) {
        this.loading = false;
        console.log(e);
      } finally {
        this.loading = false;
      }
      // this.items = await this.filterSelectedValues();
    },
    async retrieveUser() {
      this.items = this.assigneeOptions();
    },
    async retreiveChatter() {
      this.currentPage = 1;
      let params = {};
      if (this.keyword != '') {
        params.keyword = this.keyword;
      }
      params.projectId = this.projectId;
      params.pageSize = 0;

      // Load chats
      try {
        this.loading = true;
        let response = await axios.post('/chatter/retrieveChatterList', params, {
          headers: {
            Authorization: accessToken()
          }
        });

        const status = response.data.status;

        if(status === "200") {
          const body = response.data.body;
          body.list.forEach((item) => {
            item.status = this.reformatState(item.status);
            if (item.selected == null) {
              item.selected = false;
            }
            if (item.type.length > 1) {
              item.type = item.type[0].toUpperCase() + item.type.slice(1).toLowerCase();
            }
            /*table에서 business category가 있는 MeMO는 'business catergory + title' 형태로 보여주기 위함.
              table에 데이터 출력할 때 key, value 형태로 되어있으므로, 위 형식에 맞게 출력되도록 속성(formatedTitle) 추가
              (title의 값을 변경하면 다른 곳에서 영향을 받기 때문) */
            if(item.businessCategory != ''){
              item['formatedTitle'] = this.reformatMemoTitle(item);
            }
            else{
              item['formatedTitle'] = item.title;
            }
          });

          if (this.items.length == 0) {
            this.items = body.list;
          } else {
            this.items.splice(0, this.items.length, ...body.list);
          }
          // Sort the list in descending order of serial number
          this.items.sort((a, b) => b.serial - a.serial);

          // Set total number of chatters
          this.total = body.total;

        } else {
          this.$bvToast.toast(response.data.message, 
          {
            title: `Notification`,
            toaster: "b-toaster-bottom-center",
            solid: true,
            appendToast: false,
            autoHideDelay: 500,
            variant: "danger"
          });
        }
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    this.clearSelectedselectedes();
    this.retreiveData();
  },
};
</script>

<style>
#chatterModal button {
    height: inherit;
}

#my-table {
    max-width: 100%;
    max-height: 100%;
    font-size: 1em;
    user-select: none;
}

.columnRate2 {
    width: 2%;
}

.columnRate3 {
    width: 3%;
}

.columnRate10 {
    width: 7%;
}

.columnRate15 {
    width: 15%;
}

.columnRate20 {
    width: 20%;
}

.columnRate25 {
    width: 25%;
}

.columnRate30 {
    width: 30%;
}

.columnRate40 {
    width: 40%;
}

.columnRate50 {
    width: 50%;
}

.columnRate60 {
    width: 60%;
}

.columnRate65 {
    width: 65%;
}

.arrow {
    position: absolute;
    top: 50%;
    opacity: .3;
}

.arrow:hover {
    opacity: 1;
    cursor: pointer;
}

.arrow-left {
    left: 0;
}

.arrow-right {
    right: 0;
}

.custom-style {
    max-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 신규 스타일 추가 */
#chatterModal.overflow-auto {
    height: 453px !important;
    padding: 1px;
    font-family: 'NanumGothic';
}

#chatterModal.overflow-auto::-webkit-scrollbar {
    width: 16px;
    border-left: 10px solid transparent;
    background-clip: padding-box;
}

#chatterModal.overflow-auto::-webkit-scrollbar-track {
    width: 6px;
    background-color: #F6F6FA;
    border-left: 10px solid transparent;
    background-clip: padding-box;
}

#chatterModal.overflow-auto::-webkit-scrollbar-thumb {
    width: 100%;
    background-color: #C4C4CD;
    border-left: 10px solid transparent;
    background-clip: padding-box;
}

#chatterModal .table thead tr {
    background-color: transparent;
    box-shadow: 0 -1px 0 0 #DDDDE3,
    -1px 0 0 0 #DDDDE3,
    1px 0 0 0 #DDDDE3;
    border-radius: 10px 10px 0 0;
    border: none;
}

#chatterModal .table .thead-light th {
    padding: 0.666rem;
    background: #F6F6FA;
    color: #2E2E38;
    text-align: center;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 700;
    line-height: 150%;
}

#chatterModal .table .thead-light th:first-child {
    border-radius: 10px 0 0 0;
}

#chatterModal .table .thead-light th:last-child {
    border-radius: 0 10px 0 0;
}

#chatterModal .table tbody {
    box-shadow: 0 0 0 1px #DDDDE3;
    border-radius: 0 0 10px 10px;
}

#chatterModal .table tbody tr {
    box-shadow: 0 1px 0 0 #DDDDE3;
}

#chatterModal .table tbody tr:last-child {
    box-shadow: none;
    border-radius: 0 0 10px 10px;
}

#chatterModal .table tbody td {
    padding: 0.666rem;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
}
</style>
